import React from 'react';
import ChatHeader from '../molecules/ChatHeader';
import ChatMessageList from '../molecules/ChatMessageList';
import ChatInputArea from '../molecules/ChatInputArea';

const GenericChat = ({ 
  chatHook,
  config = {}
}) => {
  const {
    messages,
    inputMessage,
    isLoading,
    isTyping,
    error,
    handleInputChange,
    handleSendMessage
  } = chatHook();

  const {
    title,
    subtitle,
    avatar,
    placeholder,
    gradientFrom,
    gradientTo,
    isOnline = true
  } = config;

  return (
    <div className="flex flex-col h-full bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
      <ChatHeader 
        title={title}
        subtitle={subtitle}
        avatar={avatar}
        isOnline={isOnline}
        gradientFrom={gradientFrom}
        gradientTo={gradientTo}
      />
      
      <ChatMessageList 
        messages={messages}
        isLoading={isLoading}
        isTyping={isTyping}
      />
      
      <ChatInputArea
        inputValue={inputMessage}
        onInputChange={handleInputChange}
        onSend={handleSendMessage}
        disabled={!!error}
        isLoading={isLoading}
        placeholder={placeholder}
        gradientFrom={gradientFrom}
        gradientTo={gradientTo}
      />
    </div>
  );
};

export default GenericChat;